// =============================================
// useCloudflareTab — zakladka panelu /cloudflare sterowana query paramem ?tab=
//
// Dzieki temu /cloudflare?tab=historia da sie podlinkowac (np. z kreatora
// "Zobacz w Historii"), a stary adres /dns moze przekierowac prosto do
// kreatora "Przenies domeny". Nieznana wartosc => domyslna zakladka.
// =============================================
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const CF_TABS = ["przenies", "domeny", "dns", "pages", "konta", "historia"] as const;
export type CfTab = (typeof CF_TABS)[number];

const isCfTab = (v: string | null): v is CfTab => !!v && (CF_TABS as readonly string[]).includes(v);

export function useCloudflareTab(defaultTab: CfTab = "przenies"): [CfTab, (t: CfTab) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const tab: CfTab = isCfTab(raw) ? raw : defaultTab;

  const setTab = useCallback(
    (t: CfTab) => {
      // replace: przelaczanie zakladek nie zasmieca historii przegladarki
      setParams({ tab: t }, { replace: true });
    },
    [setParams],
  );

  return [tab, setTab];
}
